<!--
 * @Author: gaoxueting
 * @Date: 2020-06-03 18:19:39
 * @LastEditTime: 2020-08-11 10:32:02
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/modules/cloudmgt/env/components/acl/relatedsubnet.vue
-->
<template>
    <div class="project-subnet">
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr">
            <Button slot="tootipL"
                    @click="refresh">
                <i class="icon-refresh-o-2"></i>
            </Button>
            <Button slot="tootipL"
                    :disabled="!hasPermission('CB090504')"
                    @click="relatedSubnet"
                    type="primary">
                <span>{{$t('关联')}}</span>
            </Button>
        </rcTable>
        <relatedsubnet ref="relatedsubnet"
                       :id="id"
                       :envId="envId"
                       :envType="envType"
                       type="acl"
                       @refresh="refresh" />
        <cancelRelated ref="cancelRelated"
                       :id="id"
                       :envId="envId"
                       :envType="envType"
                       type="acl"
                       @refresh="refresh" />
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api.js'
import relatedsubnet from './related.vue'
import cancelRelated from './cancelrelated.vue'
export default {
    props: ['id', 'envId', 'envType', 'baseInfo'],
    components: {
        rcTable,
        relatedsubnet,
        cancelRelated
    },
    data () {
        return {
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ACL_SUBNET, false),
                    params: {
                        cloudEnvId: this.envId,
                        fireWallId: this.id
                    }
                },
                searchColumns: [
                    {
                        key: 'networkName',
                        title: this.$t('子网'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'cidr',
                        title: this.$t('网段'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'vpcName',
                        title: this.$t('网络'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                pageData: {
                    show: false
                },
                columns: [
                    {
                        title: this.$t('子网'),
                        key: 'networkName',
                        sortKey: 'name',
                        sortable: true,
                        className: 'ellipsis',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.networkName } }, params.row.networkName)
                        }
                    },
                    {
                        key: 'cidr',
                        title: this.$t('网段'),
                        sortable: true,
                        searchType: 'select',
                        searchData: [],
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true
                    },
                    {
                        title: this.$t('私有网络'),
                        key: 'vpcName',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.vpcName } }, params.row.vpcName)
                        }
                    },
                    {
                        title: this.$i18n.t('操作'),
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', { class: { disabled: !this.hasPermission('CB090505') }, on: { click: () => this.hasPermission('CB090505') && this.cancelRelated(params.row) } }, this.$i18n.t('取消关联'))
                            ])
                        }
                    }
                ]
            },
            choosed: [],
            loading: false
        }
    },
    methods: {
        refresh () {
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        cancelRelated (row) {
            this.$refs.cancelRelated.openModal(row)
        },
        relatedSubnet () {
            const row = {
                cloudEnvId: this.envId,
                id: this.id
            }
            this.$refs.relatedsubnet.openModal(row)
        }
    }
}
</script>

<style lang="less" scoped>
.project-subnet {
    max-height: 300px;
    overflow-y: auto;
}
</style>
